import { SlideOver } from '@hakimo-ui/hakimo/ui-elements';
import { TenantsFilters } from '../../types';
import FilterPanelContent from './FilterPanelContent';

interface Props {
  open: boolean;
  filters: TenantsFilters;
  onClose: () => void;
  onApplyFilters: (filters: TenantsFilters) => void;
}

function FilterPanel(props: Props) {
  const { open, onClose, onApplyFilters, filters } = props;
  return (
    <SlideOver title="Tenant Filters" open={open} onClose={onClose}>
      <FilterPanelContent filters={filters} onApplyFilters={onApplyFilters} />
    </SlideOver>
  );
}

export default FilterPanel;
